'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _shortid = require('shortid');
var _shortid2 = _interopRequireDefault(_shortid);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var CarouselDots = function (_React$Component) {
  _inherits(CarouselDots, _React$Component);
  function CarouselDots() {
    _classCallCheck(this, CarouselDots);
    var _this = _possibleConstructorReturn(this, (CarouselDots.__proto__ || Object.getPrototypeOf(CarouselDots)).call(this));
    _this.handleDotClick = _this.handleDotClick.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    return _this;
  }
  _createClass(CarouselDots, [{
    key: 'handleDotClick',
    value: function handleDotClick(index) {
      this.props.onClick(index);
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(index) {
      this.props.onKeyPress(index);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      return _react2.default.createElement('ul', {
        className: 'carousel-dots ' + this.props.className,
        role: 'tablist'
      }, this.props.items.map(function (item, index) {
        return _react2.default.createElement('li', {
          key: 'carousel-dot-' + _shortid2.default.generate(),
          className: 'carousel-dots__item',
          id: _this2.props.id ? _this2.props.id + '-' + index : '',
          role: 'tab',
          'aria-selected': _this2.props.activeIndex === index,
          'aria-controls': _this2.props.ariaControls ? _this2.props.ariaControls + '-' + index : ''
        }, _react2.default.createElement('button', {
          className: 'carousel-dots__btn ' + (_this2.props.activeIndex === index ? 'is-active' : ''),
          onClick: function onClick() {
            return _this2.handleDotClick(index);
          },
          onKeyPress: function onKeyPress() {
            return _this2.handleKeyPress(index);
          },
          type: 'button'
        }));
      }));
    }
  }]);
  return CarouselDots;
}(_react2.default.Component);
CarouselDots.defaultProps = {
  activeIndex: -1,
  ariaControls: '',
  className: '',
  id: '',
  items: [],
  onClick: function onClick() {
    return false;
  },
  onKeyPress: function onKeyPress() {
    return false;
  }
};
CarouselDots.propTypes = {
  activeIndex: _propTypes2.default.number,
  id: _propTypes2.default.string,
  ariaControls: _propTypes2.default.string,
  className: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  onClick: _propTypes2.default.func,
  onKeyPress: _propTypes2.default.func
};
exports.default = CarouselDots;